import React from 'react';
import type { CancelledTodayItem } from '../../../../api/stays-alerts-client';
import type { StaySource } from '../../../../interfaces/stays';
import { AppButton } from '../../../button/app-button';
import { dateTimeIn, formatDayKey } from '../../../../function-utils/building-time';
import { deviceClock } from '../guide/guide-model';
import { sourceText } from '../reservations/reservation-labels';
import { CardBox, CardHead, Item, List, Muted } from './operations.styled';

/**
 * STAYS CANCELLED TODAY (plan S8, SC-2; K-61, R-S8.18). "Today" is the
 * building's; the cancelled time is an instant on the viewer's device clock.
 * First name and last initial only. Hidden when nothing was cancelled.
 */

const SHOWN = 4;

export const CancellationsTodayCard: React.FC<{
  count: number;
  items: CancelledTodayItem[];
  onView: () => void;
}> = ({ count, items, onView }) => {
  if (!count) return null;
  const zone = deviceClock().zone;

  return (
    <CardBox aria-labelledby="cancelled-today-title" data-testid="cancelled-today">
      <CardHead id="cancelled-today-title">
        {count === 1 ? '1 stay cancelled today' : `${count} stays cancelled today`}
      </CardHead>
      <List>
        {items.slice(0, SHOWN).map(it => (
          <Item key={it.reservation_id} data-reservation={it.reservation_id}>
            <span>
              {it.first_name}
              {it.last_initial ? ` ${it.last_initial}` : ''}
            </span>
            <Muted>· {sourceText(it.source as StaySource)}</Muted>
            <Muted>
              · {formatDayKey(it.check_in)}–{formatDayKey(it.check_out)}
            </Muted>
            <Muted data-at={it.cancelled_at} data-time={dateTimeIn(it.cancelled_at, zone)} data-clock-whose="you">
              · cancelled {dateTimeIn(it.cancelled_at, zone)}
            </Muted>
          </Item>
        ))}
      </List>
      <AppButton type="button" variant="ghost" onClick={onView}>
        View cancelled stays
      </AppButton>
    </CardBox>
  );
};
